import { render, staticRenderFns } from "./title_lang.vue?vue&type=template&id=6edf3e3a"
import script from "./title_lang.vue?vue&type=script&lang=js"
export * from "./title_lang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports